import axios from 'axios';
import objectKeys from 'lodash/keys';
import { useEffect, useState } from 'react';

import * as storage from '../lib/storage';

const { REACT_APP_BACKEND_URL } = process.env;

export function useFetcher() {
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('idle');
  const [response, setResponse] = useState(null);

  const fetcher = async ({
    url,
    method,
    body,
    filter,
    options,
    isSecure,
    urlReplace,
  }) => {
    setError(null);
    setStatus('pending');

    let _url = `${url}`;
    if (filter) {
      const {
        page,
        sort_field = 'created_at',
        sort_direction = 'desc',
        limit = 10,
        name = '',
        query = '',
      } = options || {};
      const filterQueryString = objectKeys(filter).reduce(
        (s, filterKey) => `${s}&${filterKey}=${filter[filterKey]}`,
        '',
      );
      _url =
        _url +
        `?page=${page}&sort_field=${sort_field}&limit=${limit}&sort_direction=${sort_direction}${filterQueryString}&name=${name}&query=${query}`;
    }

    try {
      const _response = await doSendRequest({
        body,
        method,
        options,
        isSecure,
        url: _url,
        urlReplace,
      });
      setResponse(_response);
      if (_response.status === 200 || _response.status === 'ok') {
        setStatus('done');
      }
    } catch (_error) {
      setError(_error);
      setStatus('error');
    }
  };

  return { fetcher, status, error, response };
}

export function useGet(url, isSecure = true, options = {}) {
  const { status, error, response } = useAxiosFetch({
    url,

    isSecure,
    method: 'get',
  });

  return { status, error, response };
}

export function usePost(url, body, isSecure = true, options = {}) {
  const { status, error, response } = useAxiosFetch({
    url,
    body,

    isSecure,
    method: 'post',
  });

  return { status, error, response };
}

export function useAxiosFetch({ url, body, method, options, isSecure = true }) {
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('idle');
  const [response, setResponse] = useState({});

  useEffect(() => {
    if (!method || !url) {
      return;
    }

    const sendRequest = async (params) => {
      setError(null);
      setStatus('pending');

      try {
        const __response = await doSendRequest(params);

        setResponse(__response);
      } catch (err) {
        setError({
          message: err.message,
        });
      }
      setStatus('done');
    };

    sendRequest({ method, url, body, isSecure });
  }, [url]);

  return { status, response, error };
}

async function doSendRequest({ url, method, body, options, isSecure = true }) {
  const params = {
    url: `${REACT_APP_BACKEND_URL}${url}`,
    method: `${method}`.toLowerCase(),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    ...(['put', 'post'].indexOf(method) > -1 ? { data: body } : {}),
  };
  if (isSecure) {
    const merchantId = storage.getItem('current_merchant');
    const accessToken = storage.getItem('access_token');

    if (!accessToken && options.strict_secure_mode === true) {
      return;
    }

    if (accessToken) {
      params.headers['merchant-id'] = merchantId;
      params.headers['access-token'] = accessToken;
      params.headers['Authorization'] = `Bearer ${accessToken}`;

      if (params.data) {
        params.data.shop_id = merchantId;
      }
    }
  }

  try {
    const { data, headers, status } = await axios(params);
    const returnData = { ...(data || {}), status };

    if (Array.isArray(data) && (status === 'ok' || status === 200)) {
      return data;
    }
    if (data && data.status === 'ok') {
      return returnData;
    } else {
      throw { response: { data: data || {}, headers, status } };
    }
  } catch (error) {
    // console.error('error: ', error);
    let parsed_err = new Error('axios_error');
    parsed_err.error_type = 'generic_error';
    parsed_err.error_message = error.message;

    if (error?.response) {
      parsed_err.error_message =
        (error.response?.data || {}).message || 'server error';

      if (400 <= error.response?.status < 500) {
        parsed_err.error_type = 'auth_error';

        if (error.response?.status === 403) {
          parsed_err.error_type = 'permission_denied';
        }
      }

      if (process.env.NODE_ENV === 'development') {
        console.log(
          `SERVER ERROR: code:${error.response?.status}, ${JSON.stringify(
            error.response?.data || {},
          )}`,
        );
      }
    }
    console.error(parsed_err);

    throw parsed_err;
  }
}

export function useMainFetcher() {
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('idle');
  const [response, setResponse] = useState(null);

  const fetcher = async ({ url, method, body, options, isSecure }) => {
    setError(null);
    setStatus('pending');
    try {
      const __response = await doSendRequest({
        url,
        body,
        method,

        isSecure,
      });

      setResponse(__response);
    } catch (_error) {
      setError(_error);
    }

    setStatus('done');
  };

  return { fetcher, status, error, response };
}

export function useDateFetcher() {
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('idle');
  const [response, setResponse] = useState(null);

  const fetcher = async ({ url, method }) => {
    setError(null);
    setStatus('pending');

    let _url = `${url}`;
    // _url = _url + date();

    try {
      const _response = await doSendRequest({
        // body,
        method,
        // filter,

        url: _url,
      });

      setResponse(_response);
    } catch (_error) {
      setError(_error);
    }

    setStatus('done');
  };

  return { fetcher, status, error, response };
}

// function date({ filter, options }) {
//   const start = moment().add(-14, "days").format("YYYY-MM-DD");
//   const end = moment().format("YYYY-MM-DD");

//   return `?start=${start}&end=${end}`;
// }
